<template>
  <v-dialog v-model="openPwa" persistent max-width="290">
    <v-card class="pwa-section pb-3">
      <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->
      <v-card-text class="text-center font-weight-bold pb-0  mt-3"
        >Add To Your HomeScreen.</v-card-text
      >
      <v-card-actions class="text-center">
        <v-btn
          class="btn btn-red-outline bg-light-danger text-danger border-0 ma-2"
          small
          text
          @click="closePWA()"
          >No</v-btn
        >
        <v-btn class="btn btn-grn-solid ma-2" small text @click="getPWA()"
          >Yes</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
export default {
  computed: {
    ...mapState({
      isLoggedin: state => {
        return state && state.user && state.user.loggedIn;
      }
    })
  },
  data() {
    return {
      dayJS,
      currentDate: dayJS().toISOString(),
      openPwa: false,
      deferredPrompt: null
    };
  },
  mounted() {
    console.log("inside mounted");
    if (this.isLoggedin) {
      console.log("inside login ");
      this.showPwaAfterFiveDay();
      this.addHomeScreen();
    }
  },
  methods: {
    addHomeScreen() {
      console.log("inside addHomeScreen");
      // Initialize deferredPrompt for use later to show browser install prompt.
      window.addEventListener("beforeinstallprompt", e => {
        console.log("beforeinstallprompt fire", e);
        this.deferredPrompt = e;
        if (this.deferredPrompt) {
          console.log(
            "inside this.deferredPrompt",
            localStorage.getItem("pwaStatus")
          );
          if (
            localStorage.getItem("pwaStatus") === null ||
            localStorage.getItem("pwaStatus") === true
              ? true
              : false
          ) {
            console.log("open pew");
            this.openPwa = true;
          } else {
            console.log("close pew");
            this.openPwa = false;
          }
          e.preventDefault();
        }
      });
    },

    getPWA() {
      console.log("click yes");
      // Show the install prompt
      this.openPwa = false;
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
      }
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then(choice => {
        console.log("choice", choice);
        if (choice.outcome === "accepted") {
          console.log("click yes final");
          localStorage.setItem("pwaStatus", true);
        } else {
          console.log("click close final");
          this.closePWA();
        }
      });
      this.deferredPrompt = null;
    },

    closePWA() {
      const nextFiveDay = dayJS()
        .add(5, "day")
        .toISOString();
      localStorage.setItem("pwaTimeOut", nextFiveDay);
      localStorage.setItem("pwaStatus", false);
      this.openPwa = false;
    },

    showPwaAfterFiveDay() {
      console.log(
        "inside showPwaAfterFiveDay",
        localStorage.getItem("pwaTimeOut")
      );
      if (localStorage.getItem("pwaTimeOut") !== null ? true : false) {
        console.log(
          "i am inside pwa rime out",
          localStorage.getItem("pwaTimeOut")
        );
        if (this.currentDate >= localStorage.getItem("pwaTimeOut")) {
          localStorage.removeItem("pwaStatus");
        }
      } else {
        console.log("i am outside pwa rime out");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pwa-section {
  height: auto !important;
  .v-card__text {
    height: auto !important;
    font-size: 17px;
  }
  .v-card__actions {
    display: block;
    .no-btn {
      background-color: #f44336;
      color: #fff;
    }
    .yes-btn {
      background-color: #01a09b;
      color: #fff;
    }
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .application
    .v-dialog__content
    .v-dialog.v-dialog--active
    .theme--light.v-sheet {
    height: auto !important;
  }

  .application .v-dialog__content .v-dialog.v-dialog--active .v-card__text {
    height: auto !important;
  }
}
</style>
